<template>
  <v-app id="app">
    <v-app-bar app dark absolute style="color:black; background-color:orange">
      <v-container class="d-flex align-center">
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
        <v-toolbar-title>
          ぱふらぼ
        </v-toolbar-title>
        <v-tabs>
          <v-tab to="/" exact="">ホーム</v-tab>
          <v-tab to="/unity1week">イベント</v-tab>
          <v-tab to="/app-list">アプリ</v-tab>
          <v-tab to="/privacy-policy">プライバシーポリシー</v-tab>
        </v-tabs>
        </v-container>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      bottom
      temporary
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item>
            <v-list-item-title>Foo</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Bar</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Fizz</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Buzz</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    data: () => ({
      drawer: false,
      group: null,
    }),

    watch: {
      group () {
        this.drawer = false
      },
    },
  }
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.v-container {
  max-width: 1200px;
}

.v-tabs {
  display: block;
}

@media screen and (max-width: 960px) {
  .v-tabs {
    display: none;
    background-color: red;
  }
}

.v-app-bar-nav-icon {
  display: none;
}

@media screen and (max-width: 960px) {
  .v-app-bar-nav-icon {
    display: block;
  }
}
</style>